import { useTranslation } from "react-i18next";

const getCategoriesWithTranslation = (t) => [
  { value: "hiking", label: t("ideas.categories.hiking"), icon: "🏃‍♂️" },
  { value: "beach", label: t("ideas.categories.beach"), icon: "🏄‍♂️" },
  { value: "snow", label: t("ideas.categories.snow"), icon: "⛷️" },
  { value: "culture", label: t("ideas.categories.culture"), icon: "🏛️" },
  { value: "food", label: t("ideas.categories.food"), icon: "🍜" },
  { value: "adventure", label: t("ideas.categories.adventure"), icon: "🧗‍♀️" },
  { value: "wildlife", label: t("ideas.categories.wildlife"), icon: "🦁" },
  { value: "urban", label: t("ideas.categories.urban"), icon: "🌆" },
  { value: "wellness", label: t("ideas.categories.wellness"), icon: "💆‍♀️" },
  {
    value: "photography",
    label: t("ideas.categories.photography"),
    icon: "📸",
  },
];

// Fallback categories for static contexts where translation function is not available
export const TRAVEL_CATEGORIES = [
  { value: "hiking", label: "Hiking & Trekking", icon: "🏃‍♂️" },
  { value: "beach", label: "Beach & Surf", icon: "🏄‍♂️" },
  { value: "snow", label: "Snow & Ski", icon: "⛷️" },
  { value: "culture", label: "Culture & Heritage", icon: "🏛️" },
  { value: "food", label: "Food & Culinary", icon: "🍜" },
  { value: "adventure", label: "Adventure Sports", icon: "🧗‍♀️" },
  { value: "wildlife", label: "Wildlife & Nature", icon: "🦁" },
  { value: "urban", label: "Urban Exploration", icon: "🌆" },
  { value: "wellness", label: "Wellness & Spa", icon: "💆‍♀️" },
  { value: "photography", label: "Photography Tours", icon: "📸" },
];

export const useTravelCategories = () => {
  const { t } = useTranslation();
  return getCategoriesWithTranslation(t);
};
